import { render } from "./LuxuryTravel06.vue?vue&type=template&id=5baaf0de&scoped=true"
import script from "./LuxuryTravel06.vue?vue&type=script&lang=js"
export * from "./LuxuryTravel06.vue?vue&type=script&lang=js"

import "./LuxuryTravel06.scss?vue&type=style&index=0&id=5baaf0de&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5baaf0de"]])

export default __exports__